import {ChangeDetectionStrategy, Component, computed, effect, inject, input} from '@angular/core';
import {Store} from '@ngrx/store';
import {selectSelectedProject} from '../../../project/service/project.selectors';
import {loadHasAllPaperEmbedding} from '../../service/embedding.actions';
import {PaperChatFilterType} from '../../dto/paper-chat';
import {selectEmbeddingLoading, selectEmbeddingState} from '../../service/embedding.selectors';
import {MatAnchor} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatToolbar} from '@angular/material/toolbar';
import {RouterLink} from '@angular/router';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {
  PaperHasEmbeddingPaperCardComponent
} from '../paper-has-embedding-paper-card/paper-has-embedding-paper-card.component';
import {loadResearchPapers} from '../../../research/services/research-paper/research-paper.actions';

@Component({
  selector: 'app-paper-embedding-list',
  imports: [
    MatAnchor,
    MatIcon,
    MatToolbar,
    RouterLink,
    MatProgressSpinner,
    PaperHasEmbeddingPaperCardComponent,
  ],
  templateUrl: './paper-embedding-list.component.html',
  styleUrl: './paper-embedding-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaperEmbeddingListComponent {
  private readonly store: Store = inject(Store);

  readonly filter = input<PaperChatFilterType>(PaperChatFilterType.ALL);

  readonly project = this.store.selectSignal(selectSelectedProject);
  private readonly embeddingState = this.store.selectSignal(selectEmbeddingState);
  readonly paperHasEmbeddings = computed(() => {
    const projectId = this.project()?.id;
    return projectId ? this.embeddingState().paperHasEmbeddings[projectId] ?? [] : [];
  });

  readonly loading = this.store.selectSignal(selectEmbeddingLoading);

  constructor() {
    effect(() => {
      const project = this.project();
      if (!project) return;
      this.store.dispatch(loadHasAllPaperEmbedding({
        projectId: project.id, filter: this.filter()
      }));
      this.store.dispatch(loadResearchPapers({projectId: project.id}));
    });
  }
}
